@if (hasBackdrop()) {
  <div class="overlay-backdrop" role="presentation" (click)="back.emit()"></div>
}
<div
  class="modal"
  role="dialog"
  aria-modal="true"
  tabindex="0"
  [attr.aria-label]="ariaLabel() || null"
  [cdkTrapFocus]="true"
  [cdkTrapFocusAutoCapture]="true"
>
  <div class="modal__pane modal__pane--left">
    <ng-content></ng-content>
  </div>
  <div class="modal__pane modal__pane--right">
    <ng-content select="[content-right]"></ng-content>
  </div>
</div>
